var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultOfficialAccountDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3B4052"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default-official-account-dark_svg__clip0_29610_32262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64 15.23L24 6.24l15.36 8.989-15.363 9.029L8.64 15.23z",
    fill: "#2E3343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.997 24.258L8.64 15.231v17.961l15.357 9.049V24.258z",
    fill: "#2A2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.997 24.258L8.64 15.231v17.961l15.357-8.934z",
    fill: "#353A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.258l15.356-9.027v17.961l-15.359 9.049L24 24.258z",
    fill: "#2A2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.258l15.356-9.027v17.961L24 24.258z",
    fill: "#575D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 19.204l8.597-5.031 8.656 5.066-8.658 5.09-8.595-5.125z",
    fill: "#2A2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.997 24.258L15.4 19.205v12.477l5.024 2.817 3.573-2.11v-8.13z",
    fill: "#575D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.997 30.491l-3.567-2.023v6.008l3.567-2.088V30.49z",
    fill: "#353A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.996 24.258l8.595-5.053v12.477l-5.022 2.817-3.573-2.11v-8.13z",
    fill: "#353A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.996 30.491l3.567-2.023v6.008l-3.567-2.088V30.49z",
    fill: "#575D70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default-official-account-dark_svg__clip0_29610_32262"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.64 6.24)",
    d: "M0 0h30.72v36H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiMzQjQwNTIiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI5NjEwXzMyMjYyKSI+CjxwYXRoIGQ9Ik04LjY0MDE0IDE1LjIzMDFMMjMuOTk5NSA2LjI0MDIzTDM5LjM2MDEgMTUuMjI4OEwyMy45OTcgMjQuMjU4TDguNjQwMTQgMTUuMjMwMVoiIGZpbGw9IiMyRTMzNDMiLz4KPHBhdGggZD0iTTIzLjk5NyAyNC4yNTg0TDguNjQwMTQgMTUuMjMwNVYzMy4xOTI0TDIzLjk5NyA0Mi4yNDA2VjI0LjI1ODRaIiBmaWxsPSIjMkEyRTNEIi8+CjxwYXRoIGQ9Ik0yMy45OTcgMjQuMjU4NEw4LjY0MDE0IDE1LjIzMDVWMzMuMTkyNEwyMy45OTcgMjQuMjU4NFoiIGZpbGw9IiMzNTNBNEIiLz4KPHBhdGggZD0iTTIzLjk5OTYgMjQuMjU4NEwzOS4zNTY0IDE1LjIzMDVWMzMuMTkyNEwyMy45OTcxIDQyLjI0MDZMMjMuOTk5NiAyNC4yNTg0WiIgZmlsbD0iIzJBMkUzRCIvPgo8cGF0aCBkPSJNMjMuOTk5NSAyNC4yNTg0TDM5LjM1NjQgMTUuMjMwNVYzMy4xOTI0TDIzLjk5OTUgMjQuMjU4NFoiIGZpbGw9IiM1NzVENzAiLz4KPHBhdGggZD0iTTE1LjQwMDQgMTkuMjA0NUwyMy45OTcxIDE0LjE3MjlMMzIuNjUyNSAxOS4yMzg4TDIzLjk5NDYgMjQuMzI4OEwxNS40MDA0IDE5LjIwNDVaIiBmaWxsPSIjMkEyRTNEIi8+CjxwYXRoIGQ9Ik0yMy45OTcxIDI0LjI1ODNMMTUuNDAwNCAxOS4yMDUxVjMxLjY4MTlMMjAuNDI0IDM0LjQ5OTRMMjMuOTk3MSAzMi4zODgxVjI0LjI1ODNaIiBmaWxsPSIjNTc1RDcwIi8+CjxwYXRoIGQ9Ik0yMy45OTcgMzAuNDkxM0wyMC40MzAyIDI4LjQ2NzhWMzQuNDc2MkwyMy45OTcgMzIuMzg3OVYzMC40OTEzWiIgZmlsbD0iIzM1M0E0QiIvPgo8cGF0aCBkPSJNMjMuOTk1NiAyNC4yNTgzTDMyLjU5MTEgMTkuMjA1MVYzMS42ODE5TDI3LjU2ODcgMzQuNDk5NEwyMy45OTU2IDMyLjM4ODFWMjQuMjU4M1oiIGZpbGw9IiMzNTNBNEIiLz4KPHBhdGggZD0iTTIzLjk5NTYgMzAuNDkxM0wyNy41NjI1IDI4LjQ2NzhWMzQuNDc2MkwyMy45OTU2IDMyLjM4NzlWMzAuNDkxM1oiIGZpbGw9IiM1NzVENzAiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yOTYxMF8zMjI2MiI+CjxyZWN0IHdpZHRoPSIzMC43MiIgaGVpZ2h0PSIzNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguNjQwMTQgNi4yNDAyMykiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgDefaultOfficialAccountDark as ReactComponent };